import React from "react";
import StudentAnswerView from "../../../models/dtos/exams/questions/StudentAnswerView";
import QuestionView from "../question-view/QuestionView";
import ExamQuestionViewState, { CourseQuestionView, ExamQuestionViewProps } from "./ExamQuestionView.models";
import './ExamQuestionView.scss';
import { NavLink } from "react-router-dom";
import QuestionPreview from "../question-preview/QuestionPreview";
import QuestionReportModal from "../question-report-modal/QuestionReportModal";
import { ExamQuestionsView } from "../../../models/dtos/exams/questions/ExamQuestionsView";

export default class ExamQuestionView extends React.PureComponent<ExamQuestionViewProps, ExamQuestionViewState> {
    constructor(props: ExamQuestionViewProps) {
        super(props);
        this.state = { coursesWithQuestions: [], showModal: false, questionAttachmentId: '', showReportModal: false, reportModalDetail: {} };
    }

    componentDidUpdate(prevProps: ExamQuestionViewProps) {
        if (prevProps.questions !== this.props.questions) {
            this.mapQuestion()
        }
    }

    mapQuestion() {
        let { coursesWithQuestions } = this.state

        if (this.props.structure != undefined && this.props.structure != null) {
            var groups: { questions: any[], orderId: number, title: string }[] = this.props.structure.map((structureItem, index) => {
                return {
                    orderId: index,
                    title: structureItem.groupTitle,
                    questions: this.props.questions?.filter(question => structureItem.courseIds.indexOf(question.courseId) != -1) ?? []
                }
            })

            let from: number = 1
            groups.map((group) => {
                coursesWithQuestions.push({
                    courseTitle: group.title ?? null,
                    questions: group.questions.map((question: any, index: number) => { return { ...question, index: from + index } }),
                    orderId: group.orderId
                })
                from += group.questions.length
                return coursesWithQuestions
            })
        } else {
            const groupByQuestions = this.props.questions.reduce((group: any, question) => {
                const { courseTitle } = question;
    
                if (courseTitle !== null) {
                    group[courseTitle] = group[courseTitle] ?? [];
                    group[courseTitle].push(question);
                    return group;
                } else {
                    return question
                }
            }, {});
    
            let from: number = 1
            Object.entries(groupByQuestions).map((item: any) => {
                coursesWithQuestions.push({
                    courseTitle: item[0] ?? null,
                    questions: item[1].map((question: any, index: number) => { return { ...question, index: from + index } }),
                    orderId: this.props.questions?.filter(question => question.courseTitle == item[0])[0].courseId,
                })
                from += item[1].length
                return coursesWithQuestions
            })
    
            if (this.props.courseIds != undefined && this.props.courseIds != null && this.props.courseIds) {
                // @ts-ignore
                coursesWithQuestions = coursesWithQuestions.sort((a, b) => this.props.courseIds.indexOf(a.orderId) - this.props.courseIds.indexOf(b.orderId));
            }
        }

        this.setState({ coursesWithQuestions: coursesWithQuestions })
        this.forceUpdate()
    }

    openPreviewModal = (attachmentId: string) => {
        this.setState({ showModal: true, questionAttachmentId: attachmentId })
    }

    closePreviewModal = () => {
        this.setState({ showModal: false })
    }

    openReportModal = (questionStoreId?: string | null, questionCategoryId?: string | null) => {
        this.setState({ showReportModal: true, reportModalDetail: { questionCategoryId: questionCategoryId, questionStoreId: questionStoreId } })
    }

    render(): React.ReactNode {
        let { questions, studentAnswers, showAllQuestion, examTimeExpired } = this.props;
        let allQuestionHasAnswer = studentAnswers.length === (questions.filter(item => item.answers !== null ? item.answers.length > 0 : []).length + questions.filter(item => item.relatedQuestions !== null).reduce((a, v) => a = a + v.relatedQuestions.length, 0))

        let { coursesWithQuestions } = this.state;

        let examEndedText;
        if (allQuestionHasAnswer && showAllQuestion)
            examEndedText = (<div className="col-12 exam-question-view-area tk-title-middle">
                <i className="mdi mdi-check-decagram check-decagram" ></i>
                <label style={{ fontSize: "22px" }}>تبریک</label>
                <label style={{ fontSize: "13px" }}>شما با موفقیت به تمامی سوالات آزمون پاسخ داده اید</label>
            </div>);
        else
            examEndedText = <></>;

        let content;
        if (!examTimeExpired)
            content = <>
                <QuestionPreview showModal={this.state.showModal} onClose={this.closePreviewModal} attachmentId={this.state.questionAttachmentId} />
                {examEndedText}
                <div className={"dropdown-list exam-question-view-area" + (allQuestionHasAnswer && showAllQuestion ? "d-none" : "")} >
                    {this.questionListView(coursesWithQuestions, studentAnswers, showAllQuestion, examTimeExpired)}
                    <div className="col-12 submit">
                        <button className="btn btn-primary tk-full-width" onClick={this.props.onFinishExam}> اتمام ازمون</button >
                    </div>
                </div>
            </>;
        else
            content = <>{this.finishExamView()}</>;

        return (<>
            {content}
        </>);
    }

    finishExamView() {
        return (<>
            <div className="col-12 exam-question-view-area tk-title-middle" >
                <i className="mdi mdi-check-decagram check-decagram" ></i>
                <label style={{ fontSize: "14px" }}>مدت زمان آزمون شما به اتمام رسیده است</label>
                <label style={{ fontSize: "12px" }}>جهت بازگشت بر روی دکمه زیر کلیک کنید</label>
            </div>
            <NavLink to={`/CurrentExam`}>
                <button className="btn btn-primary tk-full-width back-forward"> بازگشت</button >
            </NavLink>
        </>);
    }

    questionListView(
        coursesWithQuestions: CourseQuestionView[],
        studentAnswers: StudentAnswerView[],
        showAllQuestion: boolean,
        examTimeExpired: boolean,) {
        return (<>
            {
                coursesWithQuestions.map((coursesWithQuestion, key) => {
                    return <div key={key}>
                        <div className={'area-course-title'}>
                            <label>
                                {coursesWithQuestion.courseTitle}  ( {coursesWithQuestion.questions.length} سوال )
                            </label>
                        </div>
                        {this.questionView(coursesWithQuestion.questions, studentAnswers, showAllQuestion, examTimeExpired)}
                    </div>
                })
            }
        </>);
    }


    questionView(
        questions: ExamQuestionsView[],
        studentAnswers: StudentAnswerView[],
        showAllQuestion: boolean,
        examTimeExpired: boolean,) {
        return (<>
            {
                questions.map((question, key) => {
                    let relatedQuestions;

                    if (question.relatedQuestions.length > 0) {
                        relatedQuestions = (<>
                            {question.relatedQuestions.map((relatedQuestion, key) => {
                                return <QuestionView isReadyOnly={false} onHandleShowQuestionReport={this.openReportModal} onHandleShowQuestionImage={this.openPreviewModal} onHandleAnswer={this.props.updateExam} key={key} examTimeExpired={examTimeExpired} showAllQuestion={showAllQuestion} studentAnswer={studentAnswers} question={relatedQuestion} />
                            })}
                        </>);
                    }
                    else {
                        relatedQuestions = (<></>);
                    }

                    return <div key={key}>
                        <QuestionView isReadyOnly={false} onHandleShowQuestionReport={this.openReportModal} onHandleShowQuestionImage={this.openPreviewModal} onHandleAnswer={this.props.updateExam} examTimeExpired={examTimeExpired} showAllQuestion={showAllQuestion} studentAnswer={studentAnswers} question={question} />
                        {relatedQuestions}
                    </div>
                })
            }

            <QuestionReportModal questionCategoryId={this.state.reportModalDetail.questionCategoryId} questionStoreId={this.state.reportModalDetail.questionStoreId} showModal={this.state.showReportModal} onClose={() => this.setState({ showReportModal: false })} />
        </>);
    }
}